import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    useToast,
    Text,
} from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { intentionalyFloatingPromiseReturn } from 'utils/wrappers';
import { TProductKeywordsContainer } from '../ProductKeywordsContainer';

const DeleteModal = ({
    selectedProductKeywords,
    queryParams,
    deleteInitialRef,
    isDeleteOpen,
    isDeleteLoading,
    deleteProductKeywords,
    onDeleteClose,
    setSelectedProductKeywords,
}: TProductKeywordsContainer) => {
    const toast = useToast();
    const translate = useTranslation();

    const handleDeleteProductKeyword = async () => {
        try {
            await deleteProductKeywords({
                eans: selectedProductKeywords,
                getParams: queryParams,
            }).unwrap();
            onDeleteClose();
            setSelectedProductKeywords([]);

            toast({
                title: translate('product_keyword.keyword.modal.deleteSuccesful'),
                status: 'success',
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: translate('product_keyword.modal.deleteError', { err: (error as Error).message }),
                status: 'error',
                isClosable: true,
            });
        }
    };

    const handleCloseDelete = () => {
        onDeleteClose();
    };

    return (
        <Modal isCentered initialFocusRef={deleteInitialRef} isOpen={isDeleteOpen} onClose={handleCloseDelete}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader tabIndex={-1} ref={deleteInitialRef}>
                    <Text as="h3">{translate('product_keyword.modal.titleDeleteMultiple')}</Text>
                </ModalHeader>
                <ModalCloseButton mt="2" isDisabled={isDeleteLoading} />
                <ModalBody fontSize="sm">
                    <Text>{translate('product_keyword.modal.deleteInfo')}</Text>
                </ModalBody>

                <ModalFooter>
                    <Button isDisabled={isDeleteLoading} variant="outline" size="sm" mr={3} onClick={handleCloseDelete}>
                        {translate('product_keyword.cancel')}
                    </Button>
                    <Button
                        onClick={intentionalyFloatingPromiseReturn(handleDeleteProductKeyword)}
                        isLoading={isDeleteLoading}
                        colorScheme="red"
                        size="sm"
                    >
                        {translate('product_keyword.delete')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteModal;
